import { useTranslation } from 'react-i18next';

import { AssetLink } from '../../AssetLink/AssetLink';
import { Image } from '../../Image/Image';
import { EditorialHeading } from '../shared/EditorialHeading/EditorialHeading';
import { Button } from '../../Button/Button';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { FC } from 'react';
import type { ImageSources } from '../../../helpers/images';

import * as styles from './EditorialSingle.module.scss';

interface EditorialSingleProps {
  asset: SvpAssetAdditional;
  header?: string;
  content?: string;
  editorImageUrl?: string;
  imageSources: ImageSources;
}

const EditorialSingle: FC<EditorialSingleProps> = (props) => {
  const { asset, header, content, editorImageUrl, imageSources } = props;

  const { t } = useTranslation();
  const buttonLabel = t('Click to watch');

  return (
    <AssetLink asset={asset} className={styles.editorialSingle}>
      <div className={styles.aspectRatioWrapper}>
        <EditorialHeading
          imageUrl={editorImageUrl}
          header={header}
          content={content}
          className={styles.editorialHeading}
        />
        <div className={styles.imageWrapper}>
          <Image imageSources={imageSources} />
          <Button
            component="span"
            size="large"
            variant="contained"
            className={styles.button}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </AssetLink>
  );
};

export { EditorialSingle };
